export default {
  // Title
  planLibrary: 'Plan Library',

  // Search form
  taskStatus: 'Task Status',
  deviceRouteTask: 'Device/Route/Task',
  deviceRouteTaskPlaceholder: 'Please enter name',
  planTakeoffTime: 'Plan Takeoff Time',
  startTime: 'Start Time',
  endTime: 'End Time',
  query: 'Search',
  reset: 'Reset',

  // View switch
  table: 'Table',
  card: 'Card',
  batchDelete: 'Batch Delete',

  // Task status
  allTasks: 'All Tasks',
  waitingExecution: 'Waiting Execution',
  executing: 'Executing',
  paused: 'Paused',
  completed: 'Completed',
  cancelled: 'Cancelled',
  executionFailed: 'Execution Failed',

  // Task information labels
  taskName: 'Task Name',
  type: 'Type',
  routeName: 'Route Name',
  deviceName: 'Device Name',
  actualTime: 'Actual Time',
  creator: 'Creator',
  mediaUpload: 'Media Upload',
  executionProgress: 'Execution Progress',

  // Media status
  uploadImmediately: 'Upload Immediately',
  mediaUploadEmpty: 'No Media Files',
  mediaUploadToUpload: 'Pending Upload',
  mediaUploadUploading: 'Uploading',
  mediaUploadSuccess: 'Upload Successful',

  // Action buttons
  delete: 'Delete',
  suspend: 'Suspend',
  resume: 'Resume',
  viewFiles: 'View Files',
  viewRoute: 'View Route',
  downloadFile: 'Download File',
  breakpointContinueFlight: 'Breakpoint Continue Flight',
  flightReport: 'Flight Report',

  // Confirm dialogs
  deleteTaskConfirmTitle: 'After deleting the task, the relevant media files and other data will be deleted. Are you sure to delete?',
  deleteTaskConfirmOk: 'OK',
  deleteTaskConfirmCancel: 'Cancel',
  suspendTaskConfirmTitle: 'Are you sure you want to suspend the task?',
  suspendTaskConfirmOk: 'OK',
  suspendTaskConfirmCancel: 'Cancel',
  resumeTaskConfirmTitle: 'Are you sure you want to resume the task?',
  resumeTaskConfirmOk: 'OK',
  resumeTaskConfirmCancel: 'Cancel',

  // Modal
  selectExecuteOrCancelRoute: 'Please select execute route or cancel',
  cancelRoute: 'Cancel Route',
  executeRoute: 'Execute Route',
  executeRouteWarning: 'Note: You have route tasks to be executed or being executed. If you select cancel route, all tasks will be cancelled; If you select execute route, please select a route task to execute',
  pleaseSelectRouteTask: 'Please select route task',

  // Toast messages
  deleteSuccess: 'Deleted successfully',
  suspendTaskSuccess: 'Task suspended successfully',
  resumeTaskSuccess: 'Task suspension resumed',
  uploadMediaSuccess: 'Media uploaded successfully',
  breakpointContinueFlightSuccess: 'Breakpoint continue flight successful',
  cancelTaskSuccess: 'Task cancelled successfully',

  // Empty state
  noTaskData: 'No task data',

  // Table column titles
  columnPlanTakeoffTime: 'Plan Takeoff Time',
  columnActualTime: 'Actual Time',
  columnExecutionStatus: 'Execution Status',
  columnTaskName: 'Task Name',
  columnType: 'Type',
  columnRouteName: 'Route Name',
  columnDeviceName: 'Device Name',
  columnCreator: 'Creator',
  columnMediaUpload: 'Media Upload',
  columnAction: 'Action',

  // Create task
  createTask: 'Create Task',
  taskNamePlaceholder: 'Please enter task name',
  selectRoute: 'Select Route',
  selectDevice: 'Select Device',
  taskStrategy: 'Task Strategy',
  executionTime: 'Execution Time',
  startDate: 'Start Date',
  endDate: 'End Date',
  startTaskWhenBatteryReaches: 'Start task when battery capacity reaches',
  startTaskWhenStorageReaches: 'Start task when storage level reaches (MB)',
  rthAltitude: 'RTH Altitude (Relative to Dock) (m):',
  lostActionDuringFlight: 'Lost Action During Flight:',
  cancel: 'Cancel',
  confirm: 'Confirm',
  updateTime: 'Update Time',

  // Validation messages
  pleaseEnterTaskName: 'Please enter task name',
  lengthShouldBe1To20: 'Length should be 1 to 20',
  pleaseSelectRoute: 'Please select route',
  pleaseSelectDevice: 'Please select device',
  pleaseSelectTime: 'Please select time',
  pleaseSelectDate: 'Please select date',
  rthAltitudeIncorrect: 'RTH altitude incorrect',
  pleaseEnterBatteryCapacity: 'Please enter battery capacity',
  pleaseSelectLostAction: 'Please select lost action',
  pleaseSelectStartTime: 'Please select start time',
  pleaseSelectEndTime: 'Please select end time',
  endTimeMustBeGreaterThanStartTime: 'End time must be greater than start time',
  hasOverlappingTimePeriods: 'Has overlapping time periods.',

  // Task type options
  immediateExecution: 'Immediate',
  singleTask: 'One-time',
  repeatedTask: 'Repeated',

  // Out of control action options
  returnToHome: 'Return Home',
  hover: 'Hover',
  land: 'Land',
  continueExecution: 'Continue',
}
